// The heading every newer Custom page section opens with (Policies, Usual
// hours, Contact, Questions): the pro's own heading when they wrote one, or
// the design's, plus an optional line under it.

export const sectionText = (value) => (typeof value === "string" ? value.trim() : "");

// Plain text the pro typed, as paragraphs: a blank line starts a new one.
export const toParagraphs = (value) =>
  sectionText(value)
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

// One paragraph's single line breaks, kept.
export const renderLines = (paragraph) =>
  paragraph.split("\n").map((line, index, lines) => (
    <span key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </span>
  ));

const SectionHead = ({ id, heading, lede = "" }) => (
  <div className="profile-block__head">
    <h2 className="profile-block__heading" id={id}>
      {heading}
    </h2>
    {lede && <p className="profile-block__lede">{lede}</p>}
  </div>
);

export default SectionHead;
